import { Card, Skeleton } from "antd"

const OrderHistoryCardSkeleton = () => {
  return (
    <Card
      className="shadow border-b border-gray-200"
      style={{
        borderRadius: "8px",
      }}
    >
      <div className="flex-nowrap">
        <div className="flex flex-row mb-1">
          <Skeleton.Avatar
            active
            size="small"
            shape="square"
            style={{
              borderRadius: "8px",
              marginRight: "1em",
              height: "1.4em",
            }}
          />
          <Skeleton.Input active size="small" style={{ borderRadius: "8px", height: "1.4em" }} block />
        </div>
        <div className="flex flex-col ml-auto">
          <Skeleton.Input
            active
            size="small"
            style={{
              borderRadius: "8px",
              marginBottom: "4px",
              height: "1.4em",
            }}
            block
          />
          <Skeleton.Input
            active
            size="small"
            style={{
              borderRadius: "8px",
              height: "1.4em",
              marginBottom: "4px",
            }}
            block
          />
          <Skeleton.Input active size="small" style={{ borderRadius: "8px", height: "1.4em" }} block />
        </div>
      </div>
    </Card>
  )
}

export default OrderHistoryCardSkeleton
